import React from "react";
import {
  FileTextOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileImageOutlined,
  FileZipOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FileOutlined,
  CodeOutlined,
  FileMarkdownOutlined
} from "@ant-design/icons";

const FileIcon = ({ extension, size = 32, color }) => {
  const getIconComponent = ext => {
    if (!ext) return FileOutlined;

    const lowerExt = ext.toLowerCase();

    if (["pdf"].includes(lowerExt)) {
      return FilePdfOutlined;
    }

    if (["doc", "docx"].includes(lowerExt)) {
      return FileWordOutlined;
    }

    if (["xls", "xlsx", "csv"].includes(lowerExt)) {
      return FileExcelOutlined;
    }

    if (["ppt", "pptx"].includes(lowerExt)) {
      return FilePptOutlined;
    }

    if (["txt", "rtf"].includes(lowerExt)) {
      return FileTextOutlined;
    }

    if (["md", "markdown"].includes(lowerExt)) {
      return FileMarkdownOutlined;
    }

    if (["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "ico"].includes(lowerExt)) {
      return FileImageOutlined;
    }

    if (["zip", "rar", "7z", "tar", "gz", "bz2"].includes(lowerExt)) {
      return FileZipOutlined;
    }

    if (["mp4", "avi", "mkv", "mov", "wmv", "flv", "webm", "m4v"].includes(lowerExt)) {
      return VideoCameraOutlined;
    }

    if (["mp3", "wav", "flac", "aac", "ogg", "wma", "m4a"].includes(lowerExt)) {
      return AudioOutlined;
    }

    if (
      [
        "js",
        "jsx",
        "ts",
        "tsx",
        "html",
        "css",
        "scss",
        "json",
        "xml",
        "py",
        "java",
        "cpp",
        "c",
        "php",
        "rb",
        "go",
        "rs",
        "sql"
      ].includes(lowerExt)
    ) {
      return CodeOutlined;
    }

    return FileOutlined;
  };

  const getIconColor = ext => {
    if (color) return color;

    if (!ext) return "#666";

    const lowerExt = ext.toLowerCase();

    const colorMap = {
      pdf: "#d32f2f",
      doc: "#1976d2",
      docx: "#1976d2",
      xls: "#388e3c",
      xlsx: "#388e3c",
      csv: "#388e3c",
      ppt: "#f57c00",
      pptx: "#f57c00",
      txt: "#666",
      rtf: "#666",
      md: "#333",
      markdown: "#333",

      jpg: "#9c27b0",
      jpeg: "#9c27b0",
      png: "#9c27b0",
      gif: "#9c27b0",
      bmp: "#9c27b0",
      webp: "#9c27b0",
      svg: "#9c27b0",
      ico: "#9c27b0",

      zip: "#795548",
      rar: "#795548",
      "7z": "#795548",
      tar: "#795548",
      gz: "#795548",
      bz2: "#795548",

      mp4: "#e91e63",
      avi: "#e91e63",
      mkv: "#e91e63",
      mov: "#e91e63",
      wmv: "#e91e63",
      flv: "#e91e63",
      webm: "#e91e63",
      m4v: "#e91e63",
      mp3: "#ff9800",
      wav: "#ff9800",
      flac: "#ff9800",
      aac: "#ff9800",
      ogg: "#ff9800",
      wma: "#ff9800",
      m4a: "#ff9800",

      js: "#fbc02d",
      jsx: "#00bcd4",
      ts: "#3f51b5",
      tsx: "#3f51b5",
      html: "#ff5722",
      css: "#2196f3",
      scss: "#e91e63",
      json: "#4caf50",
      xml: "#ff9800",
      py: "#3776ab",
      java: "#ed8b00",
      cpp: "#00599c",
      c: "#a8b9cc",
      php: "#777bb4",
      rb: "#cc342d",
      go: "#00add8",
      rs: "#dea584",
      sql: "#336791"
    };

    return colorMap[lowerExt] || "#666";
  };

  const IconComponent = getIconComponent(extension);
  const iconColor = getIconColor(extension);

  return (
    <IconComponent
      style={{
        fontSize: size,
        color: iconColor
      }}
    />
  );
};

export default FileIcon;
